module.exports = __webpack_public_path__ + "lp/img/select.c0894963.svg";